// side-nav — default skin module
// Token disposition: pass-through (no overrides)
// NO external imports — plain JavaScript only
// NOTE: reads host.label (implementation property) for section heading; the
// contract spec names this sectionLabel but the headless uses label.

export const styles = `
  :host {
    display: flex;
    flex-direction: column;
    width: var(--run-side-nav-width, 16rem);
    background: var(--run-side-nav-background, var(--run-color-surface-raised));
    border-right: 1px solid var(--run-side-nav-border-color, var(--run-color-border-default, #e2e8f0));
    box-shadow: var(--run-side-nav-shadow, var(--run-elevation-semantic-overlay));
    padding-block: var(--run-side-nav-padding-block, var(--run-space-semantic-sm, 1rem));
    padding-inline: var(--run-side-nav-padding-inline, var(--run-space-semantic-sm, 1rem));
    box-sizing: border-box;
    overflow-y: auto;
    font-family: var(--run-side-nav-font-family, var(--run-font-semantic-family-body));
    transition: width 0.2s ease, opacity 0.2s ease;
  }

  :host([collapsed]) {
    width: var(--run-side-nav-collapsed-width, 3.5rem);
    overflow: hidden;
  }

  :host([disabled]) {
    opacity: 0.5;
    pointer-events: none;
  }

  [part="base"] {
    display: flex;
    flex-direction: column;
    gap: var(--run-side-nav-gap, var(--run-space-semantic-xs));
    flex: 1;
  }

  :host([collapsed]) [part="base"] {
    overflow: hidden;
  }

  [part="section-label"] {
    display: block;
    padding-block: var(--run-side-nav-section-header-padding-block, var(--run-space-semantic-xs, 0.5rem));
    padding-inline: var(--run-side-nav-section-header-padding-inline, var(--run-space-semantic-xs, 0.75rem));
  }

  [part="section-label-text"] {
    color: var(--run-side-nav-section-header-color, var(--run-color-text-secondary, #64748b));
    font-size: var(--run-side-nav-section-header-font-size, var(--run-font-size-xs, 11px));
    font-weight: var(--run-side-nav-section-header-font-weight, var(--run-font-semantic-weight-medium, 500));
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  :host([collapsed]) [part="section-label"] {
    display: none;
  }

  [part="content"] {
    display: contents;
  }
`;

export function render(host) {
  // label is the implementation's property name (contract calls it sectionLabel)
  const label = host.label && host.label !== 'Site navigation' ? host.label : '';

  const sectionLabelHtml = label
    ? `<span part="section-label" aria-hidden="true">
        <span part="section-label-text">${label}</span>
      </span>`
    : '';

  host.shadowRoot.innerHTML = `
    <nav part="base" aria-label="${host.label || ''}">
      ${sectionLabelHtml}
      <slot part="content"></slot>
    </nav>
  `;
}
